import { z } from "zod";
export const grantAgentAccessSchema = z
    .object({
    tenantUserId: z.string().uuid().optional(),
    groupId: z.string().uuid().optional(),
})
    .refine((data) => (data.tenantUserId ? 1 : 0) + (data.groupId ? 1 : 0) === 1, { message: "Exactly one of tenantUserId or groupId must be set" });
//# sourceMappingURL=agent-access.js.map